
function App() {
  window.location.replace('https://twitter.com/steventlive');
}

export default App;
